import type { SellerSafetyPreferences } from '@makhe/shared';

interface Props {
  value: SellerSafetyPreferences;
  onChange: (next: SellerSafetyPreferences) => void;
}

export function SellerSafetyForm({ value, onChange }: Props) {
  const set = (patch: Partial<SellerSafetyPreferences>) => onChange({ ...value, ...patch });

  return (
    <div className="space-y-4 rounded-xl border border-makhe-line/50 p-4">
      <div>
        <h3 className="font-display text-sm font-semibold">Your safety preferences</h3>
        <p className="mt-1 text-xs text-makhe-muted">
          You control who you accept and where you meet. You can change these anytime in settings.
        </p>
      </div>

      <label className="flex items-start gap-2 text-sm">
        <input
          type="checkbox"
          checked={value.womenClientsOnly ?? false}
          onChange={(e) => set({ womenClientsOnly: e.target.checked })}
          className="mt-0.5"
        />
        <span>Women clients only — decline booking requests from male buyers.</span>
      </label>

      <label className="flex items-start gap-2 text-sm">
        <input
          type="checkbox"
          checked={value.sameInstitutionOnly ?? false}
          onChange={(e) => set({ sameInstitutionOnly: e.target.checked })}
          className="mt-0.5"
        />
        <span>Same institution only — only students at my university can book me.</span>
      </label>

      <label className="flex items-start gap-2 text-sm">
        <input
          type="checkbox"
          checked={value.requireSharedSpotForFirstBooking !== false}
          onChange={(e) => set({ requireSharedSpotForFirstBooking: e.target.checked })}
          className="mt-0.5"
        />
        <span>
          First bookings must be at a shared public spot or my location (not a buyer&apos;s room).
        </span>
      </label>

      <label className="block text-sm">
        <span className="text-makhe-muted">No residence calls after (hour, 24h)</span>
        <select
          className="mt-1 w-full rounded-lg border border-makhe-line bg-makhe-bg px-3 py-2 text-sm"
          value={value.noResidenceCallsAfterHour ?? ''}
          onChange={(e) =>
            set({
              noResidenceCallsAfterHour: e.target.value ? Number(e.target.value) : undefined,
            })
          }
        >
          <option value="">No curfew</option>
          {[18, 19, 20, 21].map((h) => (
            <option key={h} value={h}>
              {h}:00
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
